// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a43ad3ae2738305214d3","293":"a9208eb3870dd2dcfdfc","518":"9a96e382eac316fe20da","779":"ad69021e45df5b9d2bdf"}[chunkId] + ".js";
};